/**
 * Example of a nudge for the software backlog route.
 */
export const AiRovoSoftwareBacklogNudgesProvider = () => {
	return null;
};
